import React from "react";
import Form, { FormItemProps } from "antd/es/form";
import Checkbox from "antd/es/checkbox/Checkbox";
import styles from "../Fields.module.scss";

interface CheckboxFieldProps {
  validationMessage?: string;
}

const CheckboxField: React.FC<FormItemProps & CheckboxFieldProps> = ({
  name,
  label,
  preserve,
  required,
  validationMessage = "Заповніть це поле",
}) => {
  return (
    <Form.Item
      name={name}
      label={label}
      valuePropName="checked"
      preserve={preserve}
      rules={[{ required, message: validationMessage }]}
      className={styles.checkbox}
    >
      <Checkbox />
    </Form.Item>
  );
};

export default CheckboxField;
